import styled from "@emotion/styled";

const GridBreak = styled.div`
  width: 100%;
`;

export default GridBreak;
